// IE 2026 10 13 / ODOO-5800 (бот на бою: кнопки действий над строками сигналов не связаны с видом выбранных строк — на «План не затверджено» и на
// «Замовлення постачальнику потребує підтвердження» набор одинаковый): кнопка командной панели может нести условие doc.groupMenu.commandPanel[].enabled_when —
// список условий над полями строки (И): [{field, in: [...]}, {field, not_in: [...]}, {field, nonempty: true}] (либо одно условие объектом, либо {all: [...]}).
// Кнопка активна, если в выделении (отмеченные строки → диапазоны выделения → текущая строка — тот же порядок, что у бэка) есть хотя бы одна подходящая строка;
// иначе — неактивна (класс btn-inactive, щелчок не отправляется) с подсказкой «No applicable rows selected».
// Значение поля строки: колонка самой строки; нет колонки — условие '=' по этому полю в _DLRow.where строки отчёта или её предков (parents_), префикс doc. снимается;
// поле у строки неизвестно — условие НЕ запрещает (решает бэк: строка отчёта разворачивается в строки источника). Флаг fe.ux.buttonsEnabledWhen (дефолт ВКЛ;
// выключен — все кнопки активны, как раньше). Чистые функции — юнит tests/unit/buttonsEnabledWhen.test.mjs.
export const EW_FLAG = 'fe.ux.buttonsEnabledWhen'
export const EW_REASON = 'No applicable rows selected'
export const EW_MAX_ROWS = 5000

export function ew_on(setting) {
    try { return typeof setting !== 'function' || setting(EW_FLAG, true) !== false } catch (e) { return true }
}

function _key(k) {
    const s = String(k == null ? '' : k)
    return s.startsWith('doc.') ? s.slice(4) : s
}

function _whereValue(dlrow, field) {
    for (const w of (dlrow && Array.isArray(dlrow.where)) ? dlrow.where : []) {
        if (!w || typeof w !== 'object' || !['', '=', undefined, null].includes(w.condition)) continue
        const lv = (w.leftValue && typeof w.leftValue === 'object') ? w.leftValue.value : w.leftValue
        if (_key(lv) !== field) continue
        const rv = (w.rightValue && typeof w.rightValue === 'object') ? w.rightValue.value : w.rightValue
        if (rv !== undefined && rv !== null && typeof rv !== 'object') return rv
    }
    return undefined
}

// значение поля строки: колонка → условие строки отчёта → условие предков; undefined — неизвестно
// IE 2026 10 13 / ODOO-5800 (бот dev02: у строк дерева отчёта ниже уровня metric нет колонки metric и нет parents_): строка из ew_rows может прийти обёрткой
// { _ewItem: dataItem, _ewUp: [dataItem предков грида, ближний первым] } — поля нет у самой строки → колонка / условие ближайшего предка
export function ew_rowValue(row, field) {
    if (!row || typeof row !== 'object') return undefined
    if (row._ewItem) {   // IE 2026 10 13 / ODOO-5800
        let v = ew_rowValue(row._ewItem, field)
        for (let i = 0; v === undefined && i < (Array.isArray(row._ewUp) ? row._ewUp.length : 0); i++) v = ew_rowValue(row._ewUp[i], field)
        return v
    }
    if (Object.prototype.hasOwnProperty.call(row, field) && row[field] !== undefined) return row[field]
    let v = _whereValue(row._DLRow, field)
    if (v !== undefined) return v
    for (const p of Array.isArray(row.parents_) ? row.parents_ : []) {
        if (p && typeof p === 'object') {
            v = _whereValue(p._DLRow, field)
            if (v !== undefined) return v
        }
    }
    return undefined
}

export function ew_conds(ew) {
    if (!ew) return []
    if (Array.isArray(ew)) return ew.filter(c => c && typeof c === 'object' && c.field)
    if (Array.isArray(ew.all)) return ew.all.filter(c => c && typeof c === 'object' && c.field)
    return ew.field ? [ew] : []
}

export function ew_condOk(row, c) {
    const v = ew_rowValue(row, c.field)
    if (v === undefined) return true   // неизвестно — не запрещаем
    const s = v === null ? '' : String(v)
    if (Array.isArray(c.in) && !c.in.map(String).includes(s)) return false
    if (Array.isArray(c.not_in) && c.not_in.map(String).includes(s)) return false
    if (c.nonempty && !s.trim()) return false
    return true
}

export function ew_rowOk(row, ew) {
    return ew_conds(ew).every(c => ew_condOk(row, c))
}

// кнопка активна: условия нет — да; иначе хотя бы одна строка выделения подходит
export function ew_enabled(rows, ew) {
    if (!ew_conds(ew).length) return true
    return (rows || []).some(r => ew_rowOk(r, ew))
}

// IE 2026 10 13 / ODOO-5800: уровень строки дерева грида (wijmo GroupRow.level: 0 — верхний); строка данных без уровня — глубже любой группы
function _lvl(r) { return r && typeof r.level === 'number' ? r.level : Infinity }

// IE 2026 10 13 / ODOO-5800: предки строки i грида (dataItem групп-строк выше с меньшим уровнем), ближний первым — со стеком уровней для протяжки
export function ew_upChain(rows, i) {
    const out = []
    let lv = _lvl(rows[i])
    for (let j = i - 1; j >= 0 && lv > 0; j--) {
        const l = _lvl(rows[j])
        if (l < lv) { out.push({ level: l, item: rows[j] && rows[j].dataItem }); lv = l }
    }
    return out
}

// IE 2026 10 13 / ODOO-5800: строка выделения — dataItem, при предках — обёртка { _ewItem, _ewUp } (см. ew_rowValue)
function _wrap(d, up) {
    const items = up.map(u => u.item).filter(x => x && typeof x === 'object')
    return items.length ? { _ewItem: d, _ewUp: items } : d
}

// строки выделения грида (wijmo FlexGrid): отмеченные видимые → строки диапазонов выделения → текущая
// IE 2026 10 13 / ODOO-5800: каждая строка — с предками дерева грида (ew_upChain): поле, которого у строки нет (metric у строк ниже уровня metric), берётся у ближайшего предка
export function ew_rows(flex) {
    if (!flex || !flex.rows) return []
    const rows = flex.rows
    const n = rows.length != null ? rows.length : 0
    const marked = []
    const stack = []
    for (let i = 0; i < n; i++) {
        const r = rows[i]
        const l = _lvl(r)
        while (stack.length && stack[stack.length - 1].level >= l) stack.pop()
        const d = r && r.dataItem
        if (r && r.isVisible && d && d._fe && d._fe.selected) marked.push(_wrap(d, stack.slice().reverse()))
        stack.push({ level: l, item: d })
    }
    if (marked.length) return marked
    const out = [], seen = new Set()
    for (const sr of flex.selectedRanges || []) {
        if (!sr || sr.row < 0) continue
        const a = Math.min(sr.row, sr.row2), b = Math.min(Math.max(sr.row, sr.row2), n - 1)
        if (a > b) continue
        const st = ew_upChain(rows, a).reverse()   // дальний первым
        for (let i = a; i <= b && out.length < EW_MAX_ROWS; i++) {
            const r = rows[i]
            const l = _lvl(r)
            while (st.length && st[st.length - 1].level >= l) st.pop()
            const d = r && r.dataItem
            if (d && !seen.has(d)) { seen.add(d); out.push(_wrap(d, st.slice().reverse())) }
            st.push({ level: l, item: d })
        }
    }
    if (out.length) return out
    const cur = flex.collectionView && flex.collectionView.currentItem
    if (!cur) return []
    for (let i = 0; i < n; i++) if (rows[i] && rows[i].dataItem === cur) return [_wrap(cur, ew_upChain(rows, i))]
    return [cur]
}

// пометить кнопки списков commands (командная панель виджета и её определение): inactive / inactive_reason; → число изменённых кнопок
export function ew_apply(lists, rows, on = true, binding = null) {
    let n = 0
    for (const list of lists || []) {
        for (const cmd of Array.isArray(list) ? list : []) {
            if (!cmd || !cmd.enabled_when) continue
            if (binding && cmd.binding && cmd.binding !== binding) continue
            const inactive = !!on && !ew_enabled(rows, cmd.enabled_when)
            if (!!cmd.inactive !== inactive) {
                cmd.inactive = inactive
                n++
            }
            const reason = inactive ? EW_REASON : ''
            if ((cmd.inactive_reason || '') !== reason) cmd.inactive_reason = reason
        }
    }
    return n
}
